export const Delimiter = () => {
  return (
    <svg
      width="201"
      height="2"
      viewBox="0 0 201 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="0.274414"
        y1="1.28223"
        x2="200.725"
        y2="1.28223"
        stroke="#2D2D2D"
      />
    </svg>
  );
};
